module.exports = __webpack_public_path__ + "img/黑色背景图1.069f21e1.jpg";